export const DEFAULT_PRESET_VALUES = {
    AZURE: {
        preset: 'AZURE',
        url: '',
        apiKey: '',
        models: []
    },
    OPENAI: {
        preset: 'OPENAI',
        url: 'https://api.openai.com/v1',
        apiKey: '',
        models: []
    }
};
export const GOOGLE_DEFAULT_VALUES = {
    project: '',
    region: '',
    token: '',
    models: []
};
export const BEDROCK_DEFAULT_VALUES = {
    accessKey: '',
    secretKey: '',
    region: '',
    models: []
};
export const AI_PROVIDERS = {
    openai: {
        key: 'openai',
        label: 'OpenAI'
    },
    jetbrains: {
        key: 'jetbrains',
        label: 'JetBrains AI'
    },
    google: {
        key: 'google',
        label: 'Google Vertex AI'
    },
    bedrock: {
        key: 'bedrock',
        label: 'Amazon Bedrock'
    },
    huggingFace: {
        key: 'huggingFace',
        label: 'Hugging Face'
    },
    mellum: {
        key: 'mellum',
        label: 'JetBrains Mellum'
    }
};
export const DEFAULT_PROVIDER_VALUES = {
    openai: {
        id: 'openai',
        ...DEFAULT_PRESET_VALUES.AZURE
    },
    jetbrains: {
        id: 'jetbrains',
        enableCloneFinder: false
    },
    google: {
        id: 'google',
        ...GOOGLE_DEFAULT_VALUES
    },
    bedrock: {
        id: 'bedrock',
        ...BEDROCK_DEFAULT_VALUES
    },
    huggingFace: {
        id: 'huggingFace',
        models: []
    },
    mellum: {
        id: 'mellum'
    }
};
export const AI_PRESET_OPTIONS = [
    {
        key: 'AZURE',
        label: 'Azure OpenAI'
    },
    {
        key: 'OPENAI',
        label: 'OpenAI Platform'
    }
];
export function getAiEnablingFormInitialData(configuration, assignedUsersLimit) {
    const provider = {
        [configuration.availableProviders[0].type]: {
            ...DEFAULT_PROVIDER_VALUES[configuration.availableProviders[0].type]
        }
    };
    return {
        defaultProviders: [Object.values(provider)[0].id],
        activeIdeProfilesCount: 0,
        activeUsersCount: 0,
        availableProviders: [],
        allowDataCollection: false,
        disabledByLimitsUsersCount: 0,
        assignedUsersLimit,
        allowLocalProviders: false,
        provider
    };
}
